import {Header, Pagination, TableSkeleton} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import UserFilters from '@/screens/User/List/UserFilters';

import {MerchantTable} from './MerchantTable';
import useMerchantList from './useMerchantList';

const BusinessesScreen = () => {
  const {
    isLoading,
    isSearch,
    isPageReset,
    fetchAllBusinesses,
    pageInfo,
    businessList,
    filterCount,
    currentFilters,
    filtersToApply,
    handleApplyFilters,
    clearFilters,
    handleBusinessAutoComplete,
    selectAppliedFilters,
    selectCurrentFilters,
  } = useMerchantList();
  return (
    <main
      data-cy="merchants-business-page"
      className="mt-10 mb-5 mx-4 md:mx-10"
    >
      <Header dataCy="merchant-businesses-title" title={`Businesses`} />
      <UserFilters
        filterCount={filterCount}
        currentFilters={currentFilters}
        filtersToApply={filtersToApply}
        clearFilters={clearFilters}
        selectCurrentFilters={selectCurrentFilters}
        selectAppliedFilters={selectAppliedFilters}
        handleApplyFilters={handleApplyFilters}
        handleAutoComplete={handleBusinessAutoComplete}
        isMerchant={true}
        placeholder="Search Businesses"
        dataCy="merchant-business"
      />
      <section className="pt-5 md:pt-5">
        {isLoading ? (
          <TableSkeleton />
        ) : (
          <MerchantTable businesses={businessList} />
        )}
      </section>

      {businessList && businessList.length ? (
        <Pagination
          onPageChange={fetchAllBusinesses as PaginationProps['onPageChange']}
          total={pageInfo.total}
          isSearch={isSearch}
          isPageReset={isPageReset}
        />
      ) : null}
    </main>
  );
};

export default BusinessesScreen;
